import { morningAdhkar, eveningAdhkar } from '../data/dhikrCatalog';

const key = (account, kind) => `amposter:offline-adhkar:v2:${account}:${kind}`;
export const defaultAdhkar = kind => kind === 'evening' ? eveningAdhkar : morningAdhkar;

// Selected packs are explicit offline downloads, not expiring API cache entries.
// Keep both the selection and its text together, scoped to the owning account.
export function readOfflineAdhkar(account, kind) {
  try {
    const saved = JSON.parse(localStorage.getItem(key(account, kind)));
    if (saved?.packId && Array.isArray(saved.items) && saved.items.every(item =>
      typeof item.text === 'string' && Number.isInteger(item.repeat) && item.repeat > 0)) return saved;
  } catch {}
  return { packId: 'official', items: defaultAdhkar(kind) };
}

export function saveOfflineAdhkar(account, kind, packId, items, name = '') {
  if (!account || !['morning', 'evening'].includes(kind)) return;
  const normalized = items.map(item => ({ ...item, repeat: Math.max(1, Math.floor(Number(item.repeat) || 1)) }));
  localStorage.setItem(key(account, kind), JSON.stringify({ packId, items: normalized, name }));
}
